<h2>{{'funnel.error.year.title' | translate}}</h2>
<p [innerHTML]="'funnel.error.year.body' | translate"></p>
<button mat-flat-button mat-dialog-close>{{'funnel.model.close'| translate}}</button>
